import Vue from 'vue'
import App from './App.vue'
import router from "./router/router";

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

// import VueUploadComponent from "vue-upload-component"

// Vue.component('file-upload', VueUploadComponent)
Vue.component('vue-dropzone', vue2Dropzone)

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
